/**
 * QUANDO IL CLIENT PUO' SCRIVERE SU QNEWS — un punto solo (tma-orcr-85, dispatch di flotta 2026-10-28 05:12Z).
 *
 * 🔴 IL CONFINE. Una QNews di staging NON esiste, e `.env.staging` non imposta `VITE_NEWS_API_URL`: `src/env.ts` cade sul
 * default `https://qnews.qlash.gg`, la PRODUZIONE. Una build che non e' di produzione e legge da li' attraversa gia' il
 * confine in lettura (decisione a parte, fuori da qui); se SCRIVE lo attraversa in modo che non si disfa: un voto, le
 * preferenze, il contatore delle visualizzazioni.
 *   · `POST /qnews/:id/view` passa da `optionalAuth` (qnews-limulo `middleware/optionalAuth.ts`): un token invalido NON
 *     ferma la richiesta, prosegue senza utente e il conteggio sale. Con QUALSIASI token, o senza.
 *   · voto e preferenze passano da `verifyJWT` con issuer del tenant di PRODUZIONE: dal tenant `stg-account` danno 401, ma
 *     la richiesta e' uscita; con `staging-prodtenant` (issuer giusto) riuscirebbero su dati veri.
 * ⇒ La difesa non puo' appoggiarsi al 401: sta qui, PRIMA della rete.
 *
 * LA REGOLA, a due righe:
 *  · `production` (`vite build` senza `--mode`): si scrive. E' la produzione, e QNews di produzione e' la sua.
 *  · ogni altro modo (staging, staging-prodtenant, development, test, un modo nuovo): si scrive SOLO se
 *    `VITE_NEWS_API_URL` e' DICHIARATA e NON e' l'host di produzione. Variabile assente, vuota, relativa o che non e' un URL
 *    ⇒ no. Non esiste un secondo interruttore: nessuna variabile `…_WRITE_ENABLED`, nessuna eccezione per ruolo o per utente.
 *
 * ⚠️ DEV. In `vite` (modo development) `env.newsApiUrl` e' `/qnews-api`, il proxy, che manda a `VITE_NEWS_API_URL ||
 * 'https://qnews.qlash.gg'` (`vite.config.ts`) da server a server. Per questo si giudica `env.newsDestinationUrl` (la
 * variabile NUDA, senza default) e non `env.newsApiUrl`: variabile assente ⇒ il proxy va a produzione ⇒ no. Chi sviluppa News
 * punta `VITE_NEWS_API_URL` a una QNews locale (es. `http://localhost:3002`) e la scrittura torna.
 *
 * Questo file e' PURO (nessun import): `tools/verify-news-scrittura.ts` lo esegue con `node`. La regola applicata a QUESTA build
 * sta in `lib/newsScritturaOra.ts`, che legge `@/env`.
 */

/** L'host della QNews di produzione. Si confronta l'HOST analizzato, mai una sottostringa. */
export const QNEWS_PROD_HOST = 'qnews.qlash.gg';

/**
 * `true` se `destinazione` e' un URL assoluto e il suo host NON e' `qnews.qlash.gg`.
 *
 * L'host si normalizza prima del confronto: `new URL` porta in minuscolo e toglie la porta di default da `hostname`, ma
 * NON toglie il punto finale (`qnews.qlash.gg.` e' lo stesso host di produzione), quindi si toglie qui. Lo schema non conta:
 * `http://qnews.qlash.gg` e' produzione come `https://`. Una stringa che non e' un URL, o e' relativa, NON e' una destinazione.
 */
export function destinazioneNewsNonProduzione(destinazione: string): boolean {
  try {
    const host = new URL(destinazione.trim()).hostname.replace(/\.+$/, '').toLowerCase();
    return host.length > 0 && host !== QNEWS_PROD_HOST;
  } catch {
    return false;
  }
}

/** La regola, pura: `modo` e' `import.meta.env.MODE`, `destinazione` e' `VITE_NEWS_API_URL` senza default. */
export function newsScritturaConsentita(modo: string, destinazione: string): boolean {
  if (modo === 'production') return true;
  return destinazione.trim().length > 0 && destinazioneNewsNonProduzione(destinazione);
}
